import React, { useState, useEffect, useRef, useContext } from "react";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import Container from "@material-ui/core/Container";
import Nav from "./Nav";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import AppBar from "@material-ui/core/AppBar";
import SwipeableViews from "react-swipeable-views";
import PropTypes from "prop-types";
import Toolbar from "@material-ui/core/Toolbar";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Slide from "@material-ui/core/Slide";
import MenuItem from "@material-ui/core/MenuItem";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import TablePagination from "@material-ui/core/TablePagination";
import EditIcon from "@material-ui/icons/Edit";
import { UserContext } from "./UserContext";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  table: {},
  toolbar: theme.mixins.toolbar,
  content: {
    [theme.breakpoints.up("sm")]: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
    },
  },
}));

export default function Tracking(props) {
  const classes = useStyles();
  const theme = useTheme();
  const { user: currentUser } = useContext(UserContext);

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => setValue(newValue);
  const handleChangeIndex = (index) => setValue(index);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const [users, setUsers] = useState([]);
  const [whitelistedUsers, setWhitelistedUsers] = useState([]);
  const [nonWhitelistedUsers, setNonWhitelistedUsers] = useState([]);
  const [usersNeedingWhitelist, setUsersNeedingWhitelist] = useState([]);
  const [bannedUsers, setBannedUsers] = useState([]);

  const loadUsers = () => {
    fetch(`${process.env.REACT_APP_API_URL}/api/admin/users`, { credentials: "include" })
      .then((r) => r.json())
      .then((json) => filterUsers(json));
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const filterUsers = (all) => {
    setUsers(all);
    setWhitelistedUsers(all.filter((u) => u.whitelist === "Whitelisted"));
    setNonWhitelistedUsers(all.filter((u) => u.whitelist !== "Whitelisted"));
    setUsersNeedingWhitelist(all.filter((u) => u.whitelist === "Accepted"));
    setBannedUsers(all.filter((u) => u.whitelist === "Banned"));
  };

  // ── Steam ID search ──────────────────────────────────────────────────────────
  const [steamSearch, setSteamSearch] = React.useState("");
  const match = (u) =>
    !steamSearch || (u.steamId && u.steamId.toLowerCase().includes(steamSearch.toLowerCase()));

  const filteredWhitelisted = whitelistedUsers.filter(match);
  const filteredNonWhitelisted = nonWhitelistedUsers.filter(match);
  const filteredNeedingWhitelist = usersNeedingWhitelist.filter(match);
  const filteredBanned = bannedUsers.filter(match);

  // ── Edit dialog ──────────────────────────────────────────────────────────────
  const [editUser, setEditUser] = useState({});
  const [openEditUser, setOpenEditUser] = React.useState(false);

  const handleClickOpenEditUser = (u) => {
    setEditUser(u);
    setOpenEditUser(true);
  };
  const handleCloseEditUser = () => setOpenEditUser(false);

  const handleRoleChangeEditUser = (event) =>
    setEditUser({ ...editUser, whitelist: event.target.value });

  const onEditedUserSubmit = (e) => {
    e.preventDefault();
    fetch(`${process.env.REACT_APP_API_URL}/api/admin/users/${editUser._id}/edit`, {
      method: "PUT",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ editUser }),
    })
      .then((r) => r.json())
      .then(() => {
        setOpenEditUser(false);
        loadUsers();
      });
  };

  const whitelistOptions = [
    { value: "Whitelisted" },
    { value: "Denied" },
    { value: "Banned" },
  ];

  // ── PK dialog ─────────────────────────────────────────────────────────────────
  const [pkDialogOpen, setPkDialogOpen] = React.useState(false);
  const [pkTarget, setPkTarget] = React.useState(null);

  const handleOpenPK = (u) => {
    setPkTarget(u);
    setPkDialogOpen(true);
  };

  const handlePK = () => {
    setPkDialogOpen(false);
    fetch(`${process.env.REACT_APP_API_URL}/api/admin/users/${pkTarget._id}/pk`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    })
      .then((r) => r.json())
      .then(() => loadUsers());
  };

  const form2 = useRef();

  // ── Shared table columns ──────────────────────────────────────────────────────
  const TableHeaders = () => (
    <TableRow>
      <TableCell><strong>Name</strong></TableCell>
      <TableCell><strong>Username</strong></TableCell>
      <TableCell><strong>System Role</strong></TableCell>
      <TableCell><strong>SteamID</strong></TableCell>
      <TableCell><strong>Whitelist Status</strong></TableCell>
      <TableCell align="center"><strong>Action</strong></TableCell>
    </TableRow>
  );

  const UserRow = ({ u, showPK }) => (
    <Slide direction="up" in={true} mountOnEnter unmountOnExit>
      <TableRow key={u._id}>
        <TableCell>{u.name}</TableCell>
        <TableCell>{u.email}</TableCell>
        <TableCell>{u.role}</TableCell>
        <TableCell>{u.steamId}</TableCell>
        <TableCell>{u.whitelist}</TableCell>
        <TableCell align="center">
          <Tooltip title="Modify">
            <IconButton aria-label="modify" size="small" onClick={() => handleClickOpenEditUser(u)}>
              <EditIcon />
            </IconButton>
          </Tooltip>
          {showPK && (
            <Tooltip title="Permanent Kill">
              <Button
                size="small"
                variant="contained"
                style={{ backgroundColor: "#b71c1c", color: "#fff", marginLeft: 4, fontSize: 10 }}
                onClick={() => handleOpenPK(u)}
              >
                PK
              </Button>
            </Tooltip>
          )}
        </TableCell>
      </TableRow>
    </Slide>
  );

  const paged = (arr) => arr.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <div>
      <Nav />
      <Toolbar />
      <div className={classes.content}>
        <Container maxWidth="lg" className={classes.toolbar}>
          <p />
          <TextField
            label="Search by Steam ID"
            variant="outlined"
            size="small"
            fullWidth
            value={steamSearch}
            onChange={(e) => setSteamSearch(e.target.value)}
            style={{ marginBottom: 8 }}
          />
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
            >
              <Tab label="WHITELISTED USERS" {...a11yProps(0)} />
              <Tab label="NON WHITELISTED USERS" {...a11yProps(1)} />
              <Tab label="USERS NEEDING WHITELIST" {...a11yProps(2)} />
              <Tab label="BANNED USERS" {...a11yProps(3)} />
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={value}
            onChangeIndex={handleChangeIndex}
          >
            {/* ── WHITELISTED ── */}
            <TabPanel value={value} index={0} dir={theme.direction}>
              <TableContainer component={Paper} style={{ overflowY: "hidden" }}>
                <div style={{ width: "auto", overflowX: "scroll" }}>
                  <Table aria-label="whitelisted users">
                    <TableHead><TableHeaders /></TableHead>
                    <TableBody>
                      {paged(filteredWhitelisted).map((u) => (
                        <UserRow key={u._id} u={u} showPK={true} />
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[100, 200, 300, 600]}
                component="div"
                count={filteredWhitelisted.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </TabPanel>

            {/* ── NON WHITELISTED ── */}
            <TabPanel value={value} index={1} dir={theme.direction}>
              <TableContainer component={Paper} style={{ overflowY: "hidden" }}>
                <div style={{ width: "auto", overflowX: "scroll" }}>
                  <Table aria-label="non-whitelisted users">
                    <TableHead><TableHeaders /></TableHead>
                    <TableBody>
                      {paged(filteredNonWhitelisted).map((u) => (
                        <UserRow key={u._id} u={u} showPK={false} />
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[100, 200, 300, 600]}
                component="div"
                count={filteredNonWhitelisted.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </TabPanel>

            {/* ── NEEDS WHITELIST ── */}
            <TabPanel value={value} index={2} dir={theme.direction}>
              <TableContainer component={Paper} style={{ overflowY: "hidden" }}>
                <div style={{ width: "auto", overflowX: "scroll" }}>
                  <Table aria-label="needs whitelist">
                    <TableHead><TableHeaders /></TableHead>
                    <TableBody>
                      {paged(filteredNeedingWhitelist).map((u) => (
                        <UserRow key={u._id} u={u} showPK={true} />
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[100, 200, 300, 600]}
                component="div"
                count={filteredNeedingWhitelist.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </TabPanel>

            {/* ── BANNED ── */}
            <TabPanel value={value} index={3} dir={theme.direction}>
              <TableContainer component={Paper} style={{ overflowY: "hidden" }}>
                <div style={{ width: "auto", overflowX: "scroll" }}>
                  <Table aria-label="banned users">
                    <TableHead><TableHeaders /></TableHead>
                    <TableBody>
                      {paged(filteredBanned).map((u) => (
                        <UserRow key={u._id} u={u} showPK={false} />
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[100, 200, 300, 600]}
                component="div"
                count={filteredBanned.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </TabPanel>
          </SwipeableViews>

          {/* ── Edit dialog ── */}
          <Dialog open={openEditUser} onClose={handleCloseEditUser} aria-labelledby="edit-dialog-title">
            <ValidatorForm ref={form2} onSubmit={onEditedUserSubmit} onError={(e) => console.log(e)}>
              <DialogTitle id="edit-dialog-title">USER MODIFICATION</DialogTitle>
              <DialogContent>
                <DialogContentText>Change whitelist status for {editUser.name}</DialogContentText>
                <TextValidator
                  variant="outlined"
                  select
                  fullWidth
                  label="Whitelist Status"
                  value={editUser.whitelist || ""}
                  name="editUser[whitelist]"
                  validators={["required"]}
                  errorMessages={["Please select a status"]}
                  onChange={handleRoleChangeEditUser}
                >
                  {whitelistOptions.map((o) => (
                    <MenuItem key={o.value} value={o.value}>{o.value}</MenuItem>
                  ))}
                </TextValidator>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseEditUser} color="primary">Cancel</Button>
                <Button type="submit" color="primary">Save</Button>
              </DialogActions>
            </ValidatorForm>
          </Dialog>

          {/* ── PK confirmation dialog ── */}
          <Dialog open={pkDialogOpen} onClose={() => setPkDialogOpen(false)} aria-labelledby="pk-dialog-title">
            <DialogTitle id="pk-dialog-title">CONFIRM PERMANENT KILL</DialogTitle>
            <DialogContent>
              <DialogContentText>
                This will immediately remove <strong>{pkTarget?.name}</strong> ({pkTarget?.steamId})'s whitelist from CFTools and flag their account for a mandatory character re-application. This cannot be undone.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button size="small" color="primary" variant="outlined" onClick={() => setPkDialogOpen(false)}>
                CANCEL
              </Button>
              <Button
                size="small"
                variant="contained"
                style={{ backgroundColor: "#b71c1c", color: "#fff" }}
                onClick={handlePK}
              >
                CONFIRM PK
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
      </div>
    </div>
  );
}
